export const DESTINATION_REGIONS = {
  '熱門': [
    '日本', '韓國', '泰國', '台灣', '香港', '美國', '英國', '法國'
  ],
  '亞洲 (Asia)': [
    '日本', '韓國', '泰國', '台灣', '香港', '澳門', '中國', '新加坡', 
    '馬來西亞', '越南', '菲律賓', '印尼', '印度', '馬爾地夫', '斯里蘭卡', '尼泊爾', '其他亞洲國家'
  ],
  '歐洲 (Europe)': [
    '英國', '法國', '德國', '義大利', '西班牙', '葡萄牙', '荷蘭', '比利時',
    '瑞士', '奧地利', '捷克', '匈牙利', '波蘭', '希臘', '克羅埃西亞',
    '冰島', '挪威', '瑞典', '丹麥', '芬蘭', '其他歐洲國家'
  ],
  '北美洲 (North America)': [
    '美國', '加拿大', '墨西哥', '其他北美洲國家'
  ],
  '中南美洲 (Latin America)': [
    '巴西', '阿根廷', '智利', '秘魯', '哥倫比亞', '古巴', '其他中南美洲國家'
  ],
  '大洋洲 (Oceania)': [
    '澳洲', '紐西蘭', '斐濟', '其他大洋洲國家'
  ],
  '中東與非洲 (Middle East & Africa)': [
    '阿拉伯聯合大公國', '土耳其', '埃及', '摩洛哥', '南非', '肯亞', '其他中東/非洲國家'
  ]
};

export const ALL_COUNTRIES = Array.from(
  new Set(Object.values(DESTINATION_REGIONS).flat())
).sort((a, b) => {
  // 可以選擇是否要有預設排序，這裡簡單以字串長度或預設順序
  return 0;
});
